import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { filter, map, tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { QueryOptions, MutationOptions } from "@apollo/client";
import { ApolloGraphQlService } from "../apollo/apollo-graphql.service";
import { FindDatoFromDeviceAndDataTypeBuilder } from "src/app/models/graphQL/datoFromDeviceAndDatatype.request";
import {
  AlarmaModel,
  InformaModel,
  AlarmaEvento,
} from "src/app/sections/alarmas/models/alarma-models";

@Injectable({
  providedIn: "root",
})
export class StatusService {
  constructor(
    private apollo: Apollo,
    private http: HttpClient,
    private apolloService: ApolloGraphQlService
  ) {}

  getRobotStatusFromJSONFile(): Observable<any> {
    return this.http.get("../assets/data/dashboardRobotMockup.json");
  }
}
